import React, { useState } from "react";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import BuildIcon from "@mui/icons-material/Build";

const ToolCallDisplay = ({ toolCalls }) => {
  const [expanded, setExpanded] = useState({});

  if (!toolCalls || toolCalls.length === 0) return null;

  const toggle = (id) =>
    setExpanded((prev) => ({ ...prev, [id]: !prev[id] }));

  return (
    <div style={{ marginTop: "8px" }}>
      {toolCalls.map((tc) => (
        <div
          key={tc.id}
          style={{
            border: "1px solid #e0e0e0",
            borderRadius: "8px",
            marginBottom: "6px",
            overflow: "hidden",
          }}
        >
          <button
            onClick={() => toggle(tc.id)}
            style={{
              display: "flex",
              alignItems: "center",
              gap: "8px",
              width: "100%",
              padding: "8px 12px",
              border: "none",
              backgroundColor: "#fafafa",
              cursor: "pointer",
              fontSize: "13px",
              fontWeight: 500,
              color: "#555",
              textAlign: "left",
            }}
          >
            <BuildIcon style={{ fontSize: "16px", color: "#825ee7" }} />
            <span style={{ flex: 1 }}>{tc.name}</span>
            {expanded[tc.id] ? (
              <ExpandLessIcon style={{ fontSize: "18px" }} />
            ) : (
              <ExpandMoreIcon style={{ fontSize: "18px" }} />
            )}
          </button>
          {expanded[tc.id] && (
            <div
              style={{
                padding: "10px 12px",
                fontSize: "12px",
                fontFamily: "'SF Mono', 'Fira Code', monospace",
                backgroundColor: "#fff",
                borderTop: "1px solid #e0e0e0",
                whiteSpace: "pre-wrap",
                wordBreak: "break-word",
                maxHeight: "200px",
                overflowY: "auto",
              }}
            >
              {typeof tc.args === "string"
                ? tc.args
                : JSON.stringify(tc.args, null, 2)}
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default ToolCallDisplay;
